import React, { useState, useEffect } from "react";
import { FaTimes } from "react-icons/fa";
import BtnGuardar from "../../../components/buttons/BtnGuardar";
import BtnCancelar from "../../../components/buttons/BtnCancelar";
import apiRoutes from "../../../api/apiRoutes";
import { appFetchJson } from "../../../utils/http";

export default function CrearRubro({
  onClose = () => {},
  onCreated = () => {},
}) {
  // --- ESTADOS DE CAMPOS ---
  const [codigo, setCodigo] = useState("");
  const [nombre, setNombre] = useState("");

  // --- ESTADOS DE UI ---
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  // Validación simple: ambos campos obligatorios
  const isValid = codigo.trim() !== "" && nombre.trim() !== "";

  // Cerrar con tecla ESC
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  const guardar = async () => {
    if (!isValid || saving) return;

    setSaving(true);
    setError("");

    try {
      const payload = {
        codigo: codigo.trim(),
        nombre: nombre.trim(),
      };

      const created = await appFetchJson(apiRoutes.rubros.create, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      onCreated(created);
      onClose();
    } catch (e) {
      console.error("Error creando rubro:", e);
      setError(e?.message || "Ocurrió un error al guardar el rubro.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal-panel-lg" onClick={(e) => e.stopPropagation()}>
        {/* HEADER */}
        <div className="modal-header flex justify-between items-center">
          <h2 className="section-title">Crear Rubro</h2>
          <button className="modal-close-x" onClick={onClose}>
            <FaTimes />
          </button>
        </div>

        {/* BODY */}
        <div className="modal-body">
          <p className="text-gray-600 mb-4 italic">
            Introduzca los datos del nuevo rubro
          </p>

          {error && (
            <div className="text-red-600 mb-3 font-medium">{error}</div>
          )}

          <div className="form-grid">
            {/* CÓDIGO */}
            <div className="form-row">
              <label className="form-label">Código *</label>
              <input
                type="text"
                className="input"
                value={codigo}
                onChange={(e) => setCodigo(e.target.value)}
                placeholder="Código del rubro"
              />
            </div>

            {/* NOMBRE */}
            <div className="form-row">
              <label className="form-label">Nombre *</label>
              <input
                type="text"
                className="input"
                value={nombre}
                onChange={(e) => setNombre(e.target.value)}
                placeholder="Nombre del rubro"
              />
            </div>
          </div>
        </div>

        {/* FOOTER */}
        <div className="modal-footer">
          <div className="btn-row">
            <BtnGuardar
              label="Guardar"
              isValid={isValid}
              saving={saving}
              onClick={guardar}
            />
            <BtnCancelar onClick={onClose} />
          </div>
        </div>
      </div>
    </div>
  );
}